"use client";

import { motion } from "framer-motion";
import { useEffect } from "react";

const Shipping = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-20"
    >
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-lg bg-white p-8 shadow-lg md:p-12">
          <h1 className="mb-8 text-center text-4xl font-bold text-gray-900">
            Shipping Policy
          </h1>

          <div className="prose prose-lg max-w-none leading-relaxed text-gray-700">
            <p className="mb-6 text-lg">
              At Nautilus Times, our operations are aligned with maritime and
              digital service delivery frameworks. While our primary offerings
              are informational, subscription-based, and non-tangible in nature,
              this Shipping Policy is provided to clarify how access,
              distribution, and delivery are structured.
            </p>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              1. Nature of Delivery
            </h2>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                Nautilus Times does not engage in the shipment of physical
                commodities unless expressly stated in specific service
                offerings.
              </li>
              <li>
                All standard services, including subscriptions, articles,
                research insights, and maritime data, are delivered
                electronically via secure digital channels.
              </li>
              <li>
                Any reference to "shipping" shall be interpreted as digital
                transmission, electronic provisioning, or licensed access rather
                than physical dispatch.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              2. Processing Timelines
            </h2>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                Upon confirmation of payment, digital access credentials or
                entitlements are provisioned typically within 24–48 hours,
                subject to system verifications.
              </li>
              <li>
                In exceptional cases where manual review or compliance
                validation is required, processing may extend further at the
                platform's discretion.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              3. Physical Deliverables (If Applicable)
            </h2>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                Where promotional materials, publications, or physical documents
                are expressly included in a subscription or purchase, dispatch
                timelines shall vary based on logistical availability, regional
                carriers, and maritime correspondence protocols.
              </li>
              <li>
                Nautilus Times shall not be liable for delays attributable to
                carriers, customs, weather disruptions, port restrictions, or
                regulatory interventions.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              4. Risk & Responsibility
            </h2>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                For digital services, delivery is deemed complete upon issuance
                of access credentials or transmission to the registered email
                address.
              </li>
              <li>
                For physical items (if applicable), liability transfers to the
                user upon dispatch and issuance of a tracking identifier.
                Nautilus Times does not assume risk of loss, delay, or damage
                caused by external logistics providers.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              5. International Considerations
            </h2>
            <ul className="mb-6 list-disc space-y-2 pl-6">
              <li>
                Where cross-border shipping is applicable, the user shall bear
                responsibility for import duties, port charges, customs
                inspections, or maritime compliance requirements.
              </li>
              <li>
                Nautilus Times disclaims liability for restrictions or
                prohibitions imposed under international maritime regulations.
              </li>
            </ul>

            <h2 className="mb-4 mt-8 text-2xl font-semibold text-gray-900">
              6. Non-Refundability of Shipping Costs
            </h2>
            <p className="mb-6">
              All shipping-related fees, once incurred, are final,
              non-refundable, and non-transferable, irrespective of delivery
              timelines, user relocation, or discretionary cancellations.
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Shipping;
